import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { UserRole } from './utils/types/common';
import { removeUserInfor } from './store/slices/userSlice';
import { cookieServices } from './services/cookieServices';
import { toast } from 'react-toastify';

/**
 * *회원 인증
 */

// * children으로 태그로 감싸진 Component가 온다.
const ProjectAuthRoute = ({ children }) => {
  const userOrNull = useAppSelector((state) => state.userSlice.userInfor);
  const dispatch = useAppDispatch();
  const { projectId } = useParams(); // URL 파라미터 받아오기

  if (!userOrNull) {
    return <Navigate to='/login' />;
  }

  const projectOrNull = userOrNull.projectAuths.find(
    (projectAuth) => projectAuth.project_id === Number(projectId),
  );

  if (
    userOrNull.role === UserRole.Admin ||
    userOrNull.role === UserRole.SuperAdmin ||
    projectOrNull
  ) {
    global.user_id = userOrNull.user_id;
    return children;
  }

  dispatch(removeUserInfor());
  cookieServices.removeUserInfo();
  toast.error('권한이 변경되었습니다. 다시 로그인 해주세요.', {
    // TODO : i18n 적용
    position: toast.POSITION.TOP_CENTER,
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
  });

  return <Navigate to='/login' />;
};

export default ProjectAuthRoute;
